(function (scope) {

scope.Header = function () {
	var me = this;
	me._header = $("header");
	me._clickCloseOpens = [];
	me._searchClickCloseOPen;
	me._singleMenuItemStyleCTA;
	me.init = function () {
		me._header.find ("a.click-close-open").each (function () {
			var options = {
				onOpenStart: function (clickCloseOpen) {
					me.onMenuOpening.apply (me, [clickCloseOpen]);
				},
				onOpen: function (clickCloseOpen) {
					me.onMenuOpen.apply (me, [clickCloseOpen]);
				},
				onCloseStart: function (clickCloseOpen) {
					me.onMenuClosing.apply (me, [clickCloseOpen]);
				},
				onClose: function (clickCloseOpen) {
					me.onMenuClose.apply (me, [clickCloseOpen]);
				}
			};
			me._clickCloseOpens.push (new ClickCloseOpen (this, options));
			if ($(this).hasClass ("menu-item-search")) {
				me._searchClickCloseOPen = me._clickCloseOpens [me._clickCloseOpens.length - 1];
			}
		});
		me._header.find ("a.menu-item-burger").on ("click.Header", function () {
			var isBurgerMenuOpen = $("header").hasClass ("is-burger-menu-open");
			if (isBurgerMenuOpen) {
				$("header").removeClass ("is-burger-menu-open");
			} else {
				me._searchClickCloseOPen.close ();
				$("header").addClass ("is-burger-menu-open");
			}
		});
		me._header.find (".menu-item-style-cta").each (function () {
			if (!$(this).parent ().siblings ().length) {
				//if this menu item is alone in its menu set ...
				//move its menu set to the top of the menu sets on tablet and mobiles
				me._singleMenuItemStyleCTA = $(this).parents (".menu-set");
				me._singleMenuItemStyleCTA.data ("menu-set-original-pos", me._header.find (".menu-set").index (me._singleMenuItemStyleCTA [0]));
			}
		});
		// close menu if user clicks on other header parts in tablet view
		me._header.find (".header-container").on ("click.Header", function (event) {
			var target = $( event.target );
			var isBurgerMenuOpen = $("header").hasClass ("is-burger-menu-open");
			if (isBurgerMenuOpen && target.hasClass('header-container')) {
				me._header.find ("a.menu-item-burger").click();
			}
		});
		// close menu if user clicks on body in desktop view
		me._header.siblings (".page").on ("click.Header", function (event) {
			var isMenuOpen = $("header a.menu-item-a.open").length;
			if (isMenuOpen) {
				me.closeAllMenus();
			}
		});
		me.initScroll ();
	};
	me._isScrollInited;
	me.initScroll = function () {
		if (!me._isScrollInited) {
			me._isScrollInited = true;
			// console.log ("Header.initScroll");
			$(window).on ("scroll.Header", function () {
				if (!$(".is-burger-menu-open").length) {
					me.show.apply (me);
					// if (!me._isMenuBusy) {
						// don't do while opening, in case menu is higher than scroll view - causing window to scroll
						me.closeAllMenus ();
					// }
				}
			});
		}
	};
	me.disableScroll = function () {
		if (me._isScrollInited) {
			me._isScrollInited = false;
			// console.log ("Header.disableScroll");
			$(window).off ("scroll.Header");
		}
	};
	me._isMenuBusy;
	me.onMenuOpening = function (menu) {
		me._isMenuBusy = true;
		me.disableScroll ();
		if (menu._clickCloseOpen.hasClass ("menu-item-search")) {
			$("header").removeClass ("is-burger-menu-open");
		}
	};
	me._isAMenuOpen;
	me.onMenuOpen = function (menu) {
		me._isMenuBusy = false;
		me._isAMenuOpen = true;
		if (menu._clickCloseOpen.hasClass ("menu-item-search")) {
			$(".search-form-container form .field input")[0].focus ();
		}
		me.initScroll ();
	};
	me.onMenuClosing = function (menu) {
		me._isMenuBusy = true;
		me.disableScroll ();
	};
	me.onMenuClose = function (menu) {
		me._isMenuBusy = false;
		me._isAMenuOpen = false;
		me.initScroll ();
	};
	// me._closeAllMenusTimeout;
	me.closeAllMenus = function () {
		// clearTimeout (me._closeAllMenusTimeout);
		// me._closeAllMenusTimeout = setTimeout (function () {
			if (me._isAMenuOpen) {
				// console.log ("closeAllMenus");
				me._isAMenuOpen = false;
				me.disableScroll ();
				for (var i = 0; i < me._clickCloseOpens.length; i++) {
					me._clickCloseOpens [i].close ();
				}
				me.initScroll ();
			}
		// }, 500);
	};
	me._hideTimeout;
	me.hide = function () {
		clearTimeout (me._hideTimeout);
		me._hideTimeout = setTimeout (function () {
			if (!me._isHidden) {
				me._isHidden = true;
				me._header.addClass ("hidden");
			}
		}, 500);
	};
	me.show = function () {
		clearTimeout (me._hideTimeout);
		if (me._isHidden) {
			me._isHidden = false;
			me._header.removeClass ("hidden");
		}
	};
	me.init ();
};

}) (window);
